module.exports = __webpack_public_path__ + "img/computerinfor.6998b328.jpg";